import React, { useMemo } from 'react'
import AnswerTypes from './small_components/AnswerTypes';
import questions from './questions_data/questions';
import questions_chi from './questions_data/questions_chi';
import { InputAdornment, Grid} from '@mui/material';
import countryList from 'react-select-country-list'
import FileUpload from './FileUpload';
import ListOfDrugs from './small_components/ListOfDrugs';



function AnswerList({ state, setState, currentQuestion, goNextQuestion, handleChange, handleChangeAndAnswer, language }) {

    const options = useMemo(() => countryList().getData(), [])

    let LanguageSelected

    if (language === "questions") {
        LanguageSelected = questions[currentQuestion].answerOptions
    } else {
        LanguageSelected = questions_chi[currentQuestion].answerOptions
    }

    switch (questions[currentQuestion].questionText) {
        default:
            return (
                <AnswerTypes
                    name="name"
                    value={state.name ?? ""}
                    state={state}
                    setState={setState}
                    handleChange={handleChange}
                    inputProps={{
                        style: { textAlign: 'center', width: '30vw' }
                    }}
                    fullWidth={true}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="input"
                    autoFocus={true} />
            )
        case "What is your email?":
            return (
                <AnswerTypes
                    name="email"
                    value={state.email ?? ""}
                    state={state}
                    setState={setState}
                    handleChange={handleChange}
                    inputProps={{
                        style: { textAlign: 'center', width: '40vw' }
                    }}
                    fullWidth={true}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="input"
                    autoFocus={true} />
            )
        case "Select your gender":
            return (
                <AnswerTypes
                    name="gender"
                    value={state.gender ?? ""}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "Do you have your raw DNA data? (if you have been tested by other genetic testing providers)":
            return (
                <FileUpload
                    state={state}
                    handleChange={handleChange}
                    currentQuestion={currentQuestion}
                    language={language}
                />
            )
        case "Date of Birth":
            return (
                <AnswerTypes
                    state={state}
                    setState={setState}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="date" />
            )
        case "What's your Weight?":
            return (
                <AnswerTypes
                    name="weight"
                    value={state.weight ?? ""}
                    state={state}
                    setState={setState}
                    handleChange={handleChange}
                    language={language}
                    endAdornment={<InputAdornment position="end">kg</InputAdornment>}
                    inputProps={{
                        'aria-label': 'weight',
                        style: { textAlign: 'center' }
                    }}
                    currentQuestion={currentQuestion}
                    type="input"
                    autoFocus={true} />
            )
        case "What's your Height?":
            return (
                <AnswerTypes
                    name="height"
                    value={state.height ?? ""}
                    state={state}
                    setState={setState}
                    handleChange={handleChange}
                    language={language}
                    endAdornment={<InputAdornment position="end">cm</InputAdornment>}
                    inputProps={{
                        'aria-label': 'height',
                        style: { textAlign: 'center' }
                    }}
                    currentQuestion={currentQuestion}
                    type="input"
                    autoFocus={true} />
            )
        case "What are your Dietary Restrictions":
            return (
                <AnswerTypes
                    name="dietary_restrictions"
                    value={state.dietary_restrictions}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "How would you describe your Activity Level":
            return (
                <AnswerTypes
                    name="activity_level"
                    value={state.activity_level}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "What's your Ethnicity":
            return (
                <div>
                    <AnswerTypes
                        name="ethnicity"
                        value={state.ethnicity ?? ""}
                        otherValue={state.ethnicity_others ?? ""}
                        description="Specify other ethnicity."
                        options={LanguageSelected}
                        state={state}
                        setState={setState}
                        handleChange={handleChange}
                        handleChangeAndAnswer={handleChangeAndAnswer}
                        currentQuestion={currentQuestion}
                        isMulti={false}
                        isSearchable={false}
                        goNextQuestion={goNextQuestion}
                        language={language}
                        type="select" />
                </div>
            )
        case "Country of Birth":
            return (
                <AnswerTypes
                    name="country_of_birth"
                    value={state.country_of_birth ?? ""}
                    options={options}
                    state={state}
                    setState={setState}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    goNextQuestion={goNextQuestion}
                    language={language}
                    isMulti={false}
                    isSearchable={true}
                    type="select" />
            )
        case "For an accurate assessment of health & wellness risk predispositions, it is important to know your ancestry. To the best of your ability, please provide us with the ancestry (origins) of your grandparents (e.g. 50% Asian & 50% European or 100% West Asian etc.) Please indiciate NA if you are unsure.":
            return (
                <div>
                    <Grid Container xs={12} maxWidth="100%">
                        <Grid item xs={12} margin="24px">
                            <AnswerTypes
                                name="grandmother"
                                value={state.grandmother ?? ""}
                                state={state}
                                setState={setState}
                                handleChange={handleChange}
                                language={language}
                                endAdornment={<InputAdornment position="end">Grandmother</InputAdornment>}
                                inputProps={{
                                    'aria-label': 'weight',
                                    style: { textAlign: 'center', width: '40vw' }
                                }}
                                currentQuestion={currentQuestion}
                                autoFocus={true}
                                type="input" />
                        </Grid>
                        <Grid item xs={12} margin="48px 24px">
                            <AnswerTypes
                                name="grandfather"
                                value={state.grandfather ?? ""}
                                state={state}
                                setState={setState}
                                handleChange={handleChange}
                                language={language}
                                endAdornment={<InputAdornment position="end">Grandfather</InputAdornment>}
                                inputProps={{
                                    'aria-label': 'weight',
                                    style: { textAlign: 'center', width: '40vw' }
                                }}
                                currentQuestion={currentQuestion}
                                type="input"
                                autoFocus={false} />
                        </Grid>
                    </Grid>
                </div>
            )
        case "Genetic Report Language if applicable":
            return (
                <AnswerTypes
                    name="report_language"
                    value={state.report_language ?? ""}
                    options={LanguageSelected}
                    state={state}
                    setState={setState}
                    goNextQuestion={goNextQuestion}
                    currentQuestion={currentQuestion}
                    language={language}
                    isMulti={false}
                    isSearchable={false}
                    type="select" />
            )
        case "Please indicate your choice of Boost flavour if applicable":
            return (
                <AnswerTypes
                    name="boost"
                    value={state.boost}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "I am generally better at exercises/sports such as lengthy hiking, marathon, race walking, triathlon and other sports that require stamina.":
            return (
                <AnswerTypes
                    name="stamina_exercise"
                    value={state.stamina_exercise}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "I am generally better at exercises/sports such as weight lifting, tennis, martial arts and kickboxing, sprinting and fast running that require substantial strength and power over short periods of time. ":
            return (
                <AnswerTypes
                    name="strength_exercise"
                    value={state.strength_exercise}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "I have frequently experienced prolonged soreness in my muscles after workout that has taken a long time to heal.":
            return (
                <AnswerTypes
                    name="soreness"
                    value={state.soreness}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "I have frequently experienced sports related injuries in my joints and muscles.":
            return (
                <AnswerTypes
                    name="sports_injuries"
                    value={state.sports_injuries}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )

        case "I often feel out of breath very soon when I am exercising.":
            return (
                <AnswerTypes
                    name="out_of_breath"
                    value={state.out_of_breath}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "I do not feel motivated to do sports or exercises at all and have a hard time creating a fitness routine for myself, although I know it is good for me.":
            return (
                <AnswerTypes
                    name="motivation"
                    value={state.motivation}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "I have a very hard time losing weight, even if I control my diet and do exercises.":
            return (
                <AnswerTypes
                    name="losing_weight"
                    value={state.losing_weight}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "When I exercise for some time, my muscles develop and shape very quickly.":
            return (
                <AnswerTypes
                    name="muscle_development"
                    value={state.muscle_development}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "I have had frequent muscle cramps during swimming, walking or other exercise activity. ":
            return (
                <AnswerTypes
                    name="muscle_cramps"
                    value={state.muscle_cramps}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "There is obesity or overweightness running in my family (including or excluding myself).":
            return (
                <AnswerTypes
                    name="obesity"
                    value={state.obesity}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "My skin sometimes feels tight and when it is stretched, it takes a bit of time for it to smoothen out again. ":
            return (
                <AnswerTypes
                    name="skin_tightness"
                    value={state.skin_tightness}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "My skin often feels dry and I have to use moisturizers quite often.":
            return (
                <AnswerTypes
                    name="dry_skin"
                    value={state.dry_skin}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "My skin gets easily irritated ":
            return (
                <AnswerTypes
                    name="skin_irritation"
                    value={state.skin_irritation}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "When outside or on the beach during a sunny day, my skin turns red fast and I get sunburns if I don’t use sunscreen.":
            return (
                <AnswerTypes
                    name="red_skin"
                    value={state.red_skin}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "I am often told that I look much younger than my age.":
            return (
                <AnswerTypes
                    name="younger"
                    value={state.younger}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "What are your main skin concerns? Please select all that apply.":
            return (
                <AnswerTypes
                    name="skin_concerns"
                    value={state.skin_concerns ?? ""}
                    otherValue={state.skin_concerns_others ?? ""}
                    description="Please state other skin concerns."
                    options={LanguageSelected}
                    state={state}
                    setState={setState}
                    currentQuestion={currentQuestion}
                    isMulti={true}
                    isSearchable={false}
                    closeMenuOnSelect={false}
                    goNextQuestion={goNextQuestion}
                    language={language}
                    type="select" />
            )
        case "Please check which of the following symptoms have you felt or exhibited frequently (tangible enough for you to have noticed it several times over this period)":
            return (
                <AnswerTypes
                    name="symptoms"
                    value={state.symptoms ?? ""}
                    options={LanguageSelected}
                    state={state}
                    setState={setState}
                    currentQuestion={currentQuestion}
                    isMulti={true}
                    isSearchable={false}
                    closeMenuOnSelect={false}
                    goNextQuestion={goNextQuestion}
                    language={language}
                    type="select" />
            )
        case "Do you smoke?":
            return (
                <AnswerTypes
                    name="smoke"
                    value={state.smoke}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "How often do you exercise per week: Endurance Workout (Eg. cardio exercises at the gym, aerobics, running, cycling)":
            return (
                <AnswerTypes
                    name="endurance_sport"
                    value={state.endurance_sport}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "How often do you exercise per week: Muscle Sport (Eg. racket games, swimming, yoga, pilates, muscle toning)":
            return (
                <AnswerTypes
                    name="muscle_sport"
                    value={state.muscle_sport}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "How many glasses of alcoholic drink do you drink per week? (E.g beer, wine, sake, cocktails, whiskey,brandy etc)":
            return (
                <AnswerTypes
                    name="alcoholic"
                    value={state.alcoholic}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "How long do you usually spend in the sun daily? (without sunscreen)":
            return (
                <AnswerTypes
                    name="sunscreen"
                    value={state.sunscreen}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "Do you feel sufficiently rested?":
            return (
                <AnswerTypes
                    name="rested"
                    value={state.rested}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "Do you suffer from stress?":
            return (
                <AnswerTypes
                    name="stress"
                    value={state.stress}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "Do you have a physically-demanding job?":
            return (
                <AnswerTypes
                    name="physical_job"
                    value={state.physical_job}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "How many servings of fruit do you eat daily? (1 serving is roughly a apple/pear/orange/banana, a slice of papaya/melon or a small bunch of grapes)":
            return (
                <AnswerTypes
                    name="fruits"
                    value={state.fruits}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "How many servings of vegetables do you eat daily? (1 serving is 1 cup of cooked vegetables or a side plate of salad)":
            return (
                <AnswerTypes
                    name="vegetables"
                    value={state.vegetables}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "Are you a vegetarian?":
            return (
                <AnswerTypes
                    name="vegetarian"
                    value={state.vegetarian}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "How many times do you eat fish per week?":
            return (
                <AnswerTypes
                    name="fish"
                    value={state.fish}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "How many times do you eat meat per week?":
            return (
                <AnswerTypes
                    name="meat"
                    value={state.meat}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "Do you eat on a regular basis “junk food”? (Eg. potato chips, candy bars, processed snacks, etc)":
            return (
                <AnswerTypes
                    name="junk_food"
                    value={state.junk_food}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "Do you drink regularly sweetened beverages? (with sugar or artificial sweetener such as Equal)":
            return (
                <AnswerTypes
                    name="sweetened_drink"
                    value={state.sweetened_beverage}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "Do you drink regularly carbonated soft drinks?":
            return (
                <AnswerTypes
                    name="carbonated_drink"
                    value={state.carbonated_drink}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "Please select any of the conditions below if applicable. (You can select more than one)":
            return (
                <AnswerTypes
                    name="conditions"
                    value={state.conditions ?? ""}
                    options={LanguageSelected}
                    otherValue={state.conditions_others ?? ""}
                    description="Please state other conditions that are not listed."
                    state={state}
                    setState={setState}
                    currentQuestion={currentQuestion}
                    isMulti={true}
                    isSearchable={false}
                    closeMenuOnSelect={false}
                    language={language}
                    type="select" />
            )
        case "Select what your are allergic/have an allergic reaction to (You can select more than one)":
            return (
                <AnswerTypes
                    name="allergic"
                    value={state.allergic ?? ""}
                    otherValue={state.allergic_others ?? ""}
                    description="Please state other allergies that are not listed."
                    options={LanguageSelected}
                    state={state}
                    setState={setState}
                    currentQuestion={currentQuestion}
                    isMulti={true}
                    isSearchable={false}
                    closeMenuOnSelect={false}
                    language={language}
                    type="select" />
            )
        case "Select if you’ve suffered from any of the following diseases (You can select more than one)":
            return (
                <AnswerTypes
                    name="diseases"
                    value={state.diseases ?? ""}
                    otherValue={state.diseases_others ?? ""}
                    description="Please state other diseases that you've suffered that are not listed."
                    options={LanguageSelected}
                    state={state}
                    setState={setState}
                    currentQuestion={currentQuestion}
                    isMulti={true}
                    isSearchable={false}
                    closeMenuOnSelect={false}
                    language={language}
                    type="select" />
            )
        case "Many drugs are depleting the body of vital nutrients. Please mark those drugs you are currently taking (You can select more than one)":
            return (
                <div>
                    <AnswerTypes
                        name="drugs"
                        value={state.drugs ?? ""}
                        description="Please state other drugs you are taking that are not listed."
                        options={LanguageSelected}
                        state={state}
                        setState={setState}
                        currentQuestion={currentQuestion}
                        isMulti={true}
                        isSearchable={false}
                        closeMenuOnSelect={false}
                        language={language}
                        type="select" />
                    <ListOfDrugs 
                        state = {state}
                        handleChange = {handleChange}
                        language={language}/>
                </div>
            )
        case "Other medications: e.g. Warfarin, Amoxil, etc.":
            return (
                <AnswerTypes
                    name="medications"
                    value={state.medications}
                    otherValue={state.medications_others ?? ""}
                    handleChange={handleChange}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio-input" />
            )
        case "Other health conditions/concerns: e.g. fall sick easily, migraine, etc.":
            return (
                <AnswerTypes
                    name="health"
                    value={state.health}
                    otherValue={state.health_others ?? ""}
                    handleChange={handleChange}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio-input" />
            )
        case "Are you pregnant or planning to become pregnant?":
            return (
                <AnswerTypes
                    name="pregnant"
                    value={state.pregnant}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "Are you breastfeeding?":
            return (
                <AnswerTypes
                    name="breastfeeding"
                    value={state.breastfeeding}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "Are you taking any hormonal contraceptions?":
            return (
                <AnswerTypes
                    name="hormonal"
                    value={state.hormonal}
                    handleChangeAndAnswer={handleChangeAndAnswer}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="radio" />
            )
        case "Please choose 3 of your most important health goals.":
            return (
                <AnswerTypes
                    name="health_goals"
                    value={state.health_goals ?? ""}
                    otherValue={state.health_goals_others ?? ""}
                    description="Please state other health goals that you might have that are not listed."
                    options={LanguageSelected}
                    state={state}
                    setState={setState}
                    currentQuestion={currentQuestion}
                    isOptionDisabled={() => state.health_goals.length >= 3}
                    isMulti={true}
                    isSearchable={false}
                    closeMenuOnSelect={false}
                    language={language}
                    type="select" />
            )
        case "Please read our Terms of Use:":
            return (
                <AnswerTypes
                    state={state}
                    setState={setState}
                    currentQuestion={currentQuestion}
                    language={language}
                    type="terms" />
            )
    }
}

export default AnswerList